'use strict';

import lazysizes from 'lazysizes';
// rewrite this
import 'ls.bgset';
import 'ls.respimg';

/**
 * Service that wraps lazysizes
 */
function lazysizesFactory() {
  return {
    init: () => {
      lazysizes.init();
    }
  };
}

export default lazysizesFactory;



// WEBPACK FOOTER //
// ./app/src/services/lazysizes.js